module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAJOgAACToAYJjBRwAAAAhSURBVDhPY/hPIgBpWOy5hEg0qoEYNKqBGESuBhLA//8ArDXlnEk3AisAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/nonlinearstorage-node.png
// module id = 989
// module chunks = 0